import {Myerror, myWarnign} from "@/common/helpers/Alert";

export function ValidatePersian(e) {

    let char = String.fromCharCode(e.keyCode);
    componeName(e, e.target.value);

    // Get the character
    if (!/^[A-Za-z]+$/.test(char)) {
        return true; // Match with regex
    }
    if (e.keyCode !== 32) {
        e.target.value = " ";
        Myerror("لطفا فقط حروف فارسی وارد کنید");
        e.preventDefault(); // If not match, don't add to input text
        return false;
    }
}

export function ValidateNumber(e) {

    let char = String.fromCharCode(e.keyCode);

    // Get the character
    if (/^\d+$/.test(char)) {
        return true; // Match with regex
    }
    e.target.value = " ";
    Myerror("لطفا فقط اعداد وارد کنید");

    e.preventDefault(); // If not match, don't add to input text
    return false;
}

export function componeName(e, value) {
    let inputValue = e.target.value;

    // Define filter words
    const filterWords = ["شرکت", "موسسه", "آموزشگاه", "مزگر"];

    // Function to filter words and display an error if needed
    function filterAndCheckError(text) {
        let modifiedText = text;
        filterWords.forEach(word => {
            modifiedText = modifiedText.replace(new RegExp(word, 'g'), '');
        });

        if (text !== modifiedText) {
            Myerror("لطفاً از کلمات ممنوعه استفاده نکنید");
            e.target.value = ""
            return false; // Error occurred
        }

    }

    // Check for errors
    if (filterAndCheckError(inputValue)) {
        // Reset the input value to the previous valid state
        e.target.value = inputValue;
    }

}

